// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","footerBtn":"reports-journal_footerBtn__RCCjD","btn":"reports-journal_btn__YqX1Y","icon":"reports-journal_icon__-RwRT"};